import moment from "moment";
import axios from "axios";
const changeUserAction = async (
  invoicesList,
  selectedUser,
  comment, 
      setComment,
  setSelectedUser,
  setChangeUserLoading,
  setWaitMessage,
  updateForm,
  IsIRuser
) => {
  const formattedPayload = {
    Invoice_Ids: invoicesList.map((id) => id),
    IRUser: selectedUser,
    Comment : comment,
    IsIRuser
  };
  
  // Create params object with individual query parameters
  let queryParams = [];

  // Add all Invoice_Ids as separate query parameters
  formattedPayload.Invoice_Ids.forEach((id) => {
    queryParams.push(`Invoice_Ids=${id}`); // Add each invoice ID separately
  });
  
  // Add other parameters like IRUser and IsIRuser
  queryParams.push(`IRUser=${selectedUser}`);
  queryParams.push(`Comment=${comment}`);
  queryParams.push(`IsIRuser=${IsIRuser}`);

  const queryString = queryParams.join("&");
  await axios({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/UpdateIR_OR_IP?${queryString}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
   
  })
    .then(async (res) => {
      setChangeUserLoading(false);
     
      updateForm();
      setWaitMessage("");
      setSelectedUser("")
      setComment("")
    })
    .catch((err) => {
      console.log(err, "error");
    });
};

const getChangeUserInvoicesLandingPage = async (
  setInvoices,
  setInvoiceLoading,
  invoiceData,
  setCount,
  status,
  isOrderUpdated
) => {
  setInvoices([]);
  const stringified = JSON.stringify(invoiceData);
  const parsed = JSON.parse(stringified);
  let data = parsed;

  data.UserTo  = parsed?.User?.userId || data.User;
  delete data.User;
  data.InvoiceNo =  parsed?.InvoiceNo  ?  parsed?.InvoiceNo : "-1"
  data.RoleId = parsed.RoleId?.roleId || "";
  // data.RoleId = newValue?.roleId
  // data.roleName = newValue?.roleName
  data.Vendor = parsed.Vendor?.Vendor_Code || "-1";
  // data.Status = parsed?.Status?.text;
  data.Status = "Admin";
  data.InvoiceFromDate = parsed.InvoiceFromDate
    ? parsed.InvoiceFromDate
    : "1999-01-01";
  data.InvoiceToDate = parsed.InvoiceToDate
    ? parsed.InvoiceToDate
    : "9999-12-31";
  let orderBy = data.OrderBy;
  if (
    status?.text === "Processed" &&
    data?.roleName === "AP Supervisor" &&
    isOrderUpdated
  ) {
    console.log("update");
    data.OrderBy = "Updated_On";
  } else {
    console.log("order");
    // If not the first time or conditions are not met, set default order
    data.OrderBy = orderBy;
  }
  // data.OrderBy = (status?.text === "Processed" && data?.roleName === "AP Supervisor") ?  "Updated_On":  data.OrderBy;
  setInvoiceLoading(true);


  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/AdminSettings/getLandingPageOnRoleWise_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
    // data: data,
  })
    .then(async (res) => {
      setInvoices(res?.data?.listRecord);
      setCount(parseInt(res?.data?.recordsCount));
      setInvoiceLoading(false);
    })
    .catch((err) => {
      setInvoiceLoading(false);
    });
};

export { changeUserAction, getChangeUserInvoicesLandingPage };
